module.exports = __webpack_public_path__ + "img/logo.6051ef1a.png";